<app-summary *ngIf="entity"
             [badgeLabel]="displayBusinessContextLabel ? 'Tâche' : undefined"
             (clickedEvent)="view()"
             [style.cursor]="clickable ? 'pointer' : 'initial'">
    <ng-container title><strong>{{summary.label}}</strong></ng-container>

    <app-badge badges color="danger" label="En retard" *ngIf="summary.isOverdue()"></app-badge>
    <ng-container content>
        <app-summary-field>
            <app-workflow-task-status-summary-field [task]="summary"></app-workflow-task-status-summary-field>
        </app-summary-field>
        <app-summary-field *ngIf="summary.statusDetails" [value]="summary.statusDetails"></app-summary-field>
        <app-partner-summary-field [partnerSummary]="summary.partner" *ngIf="summary.partner"></app-partner-summary-field>
        <ng-container *ngFor="let attribute of summary.publicAttributes">
            <app-comment-summary-field [displayIcon]="false"
                                       *ngIf="!attribute.resultAttribute"
                                       [comment]="attribute.value"
                                       [maxLength]="40"></app-comment-summary-field>
        </ng-container>

        <app-user-summary-field *ngIf="summary.assignedUser" [entity]="summary.assignedUser"></app-user-summary-field>
        <app-datetime-summary-field *ngIf="summary.deadline"
                                    [datetime]="summary.deadline"
                                    label="Date limite"></app-datetime-summary-field>
    </ng-container>
</app-summary>

